import { CssColor, CssFont, CssVariable } from '@wix/wix-site-theme-variables';
export { CssColor, CssFont, CssVariable };
export const wixFont = variable => {
  return {
    type: 'static',
    preset: `var(--${variable})`
  };
};
export const wixColor = variable => {
  return {
    type: 'static',
    preset: `var(--${variable})`
  };
};
export const wixVariable = variable => {
  return {
    type: 'static',
    value: `var(--${variable})`
  };
};
//# sourceMappingURL=wixBrand.js.map